<div class="app-shell">
  <app-top-bar></app-top-bar>
  <main class="app-main">
    <router-outlet></router-outlet>
  </main>
</div>
